/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Tc_From_GroupInputs */

const en_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy TC From Group`)
};

const fr_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le CT du groupe`)
};

const de_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC aus Gruppe kopieren`)
};

const it_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia TC dal gruppo`)
};

const ru_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать TC из группы`)
};

const es_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar TC del grupo`)
};

const zh_cn2_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从组复制 TC`)
};

const ja_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループからTCをコピー`)
};

const hi_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह से टीसी कॉपी करें`)
};

const pt_pt2_copy_tc_from_group = /** @type {(inputs: Copy_Tc_From_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar TC do grupo`)
};

/**
* | output |
* | --- |
* | "Copy TC From Group" |
*
* @param {Copy_Tc_From_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_tc_from_group = /** @type {((inputs?: Copy_Tc_From_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Tc_From_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_tc_from_group(inputs)
	if (locale === "de") return de_copy_tc_from_group(inputs)
	if (locale === "it") return it_copy_tc_from_group(inputs)
	if (locale === "ru") return ru_copy_tc_from_group(inputs)
	if (locale === "es") return es_copy_tc_from_group(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_tc_from_group(inputs)
	if (locale === "ja") return ja_copy_tc_from_group(inputs)
	if (locale === "hi") return hi_copy_tc_from_group(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_tc_from_group(inputs)
	return en_copy_tc_from_group(inputs)
});